<template>
  <v-content>
    <v-overlay opacity="0">
      <v-container class="d-flex align-center justify-center flex-column">
        <h1 class="text--grey grey--text text--darken-4 mb-10">Cargando...</h1>
        <h3 class="text--grey grey--text text--darken-4 mb-10">{{msj}}</h3>
        <v-progress-circular
          class="text--grey grey--text text--darken-4 mb-10"
          size="50"
          width="8"
          indeterminate
          color="grey darken-4"
        ></v-progress-circular>
      </v-container>
    </v-overlay>
  </v-content>
</template>

<script>
import { configJson } from "@/utils/config";
var stripe = Stripe(configJson.stripe.api_key);

export default {
  data() {
    return {
      params: null,
      msj: "NO CIERRES ESTA VENTANA, ESTAMOS IMPRIMIENDO EL TICKET"
    };
  },
  methods: {
    //status/no-succeeded
    getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function(m, key, value) {
          vars[key] = value;
        }
      );
      return vars;
    }
  },
  mounted() {
    this.params = this.getUrlVars();
    console.log(this.params);
    if (
      !this.params.payment_intent ||
      !this.params.payment_intent_client_secret
    ) {
      this.$router.push("/");
    } else {
      this.$store
        .dispatch("pedido/comprobarPagoTokenStripe", this.params.payment_intent)
        .then(r => {
          console.log(r);
          const d = r.data;
          if (!d.ok) {
            this.msj = "ERROR EN EL PAGO";
          }
        });
    }
  }
};
</script>

<style>
</style>